import { graphql } from "@opensea/graphql"

export const useCollectionOffersFragment = graphql(`
  fragment useCollectionOffers on CollectionResult {
    __typename
    ... on Collection {
      slug
      flags {
        isOffersEnabled
      }
      traitOffersEnabled
      chain {
        identifier
        arch
      }
    }
  }
`)
